/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { PureComponent } from 'react';
import cn from 'classnames';
import { Translator } from 'ggApp/modules/translator/components';
import styles from './index.module.scss';

export default class FormsSelect extends PureComponent {
    render() {
        const {
            id,
            input,
            label,
            disabled,
            data,
            reqMark,
            globalError,
            dark,
            modern,
            meta: { active, touched, valid, error },
        } = this.props;
        const errorCondition = touched && !!error;

        return (
            <div
                className={cn(styles.formsSelect, {
                    [styles['formsSelect--error']]: errorCondition || !!globalError,
                    [styles['formsSelect--valid']]: valid,
                    [styles['formsSelect--active']]: active || input.value.length !== 0,
                    [styles['formsSelect--disabled']]: disabled,
                    [styles['formsSelect--dark']]: dark,
                    [styles['formsSelect--modern']]: modern,
                })}
            >
                <div className={styles.formsSelect__box}>
                    {label && (
                        <div className={styles.formsSelect__label}>
                            <div>
                                <Translator tk={label} /> {reqMark ? '*' : ''}
                            </div>
                        </div>
                    )}
                    <select id={id} {...input}>
                        <option value="" />
                        {data.map((c, i) => (
                            <option key={i} value={c.id}>
                                {c.name}
                            </option>
                        ))}
                    </select>
                </div>
                {errorCondition && (
                    <div className={styles.formsSelect__error}>
                        <Translator tk={error} />
                    </div>
                )}
            </div>
        );
    }
}
